'use-strict'

export default {
    SET_ALL_STADIUMS: '@@stadium/SET_ALL_STADIUMS',
    SET_ALL_SEDE_STADIUMS: '@@stadium/SET_ALL_SEDE_STADIUMS',
    CLEAR_ALL_STADIUMS: '@@stadium/CLEAR_ALL_STADIUMS',
    CLEAR_ALL_SEDE_STADIUMS: '@@stadium/CLEAR_ALL_SEDE_STADIUMS',
    SET_STADIUM_KEY_VALUE: '@@stadium/SET_STADIUM_KEY_VALUE',
    PUSH_NEW_STADIUM: '@@stadium/PUSH_NEW_STADIUM'
}